export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    // eslint-disable-next-line no-undef
    if (
      typeof window.$ === 'undefined' ||
      typeof window.$.fn === 'undefined' ||
      typeof window.$.fn.select2 === 'undefined'
    ) {
      return
    }
    document.querySelectorAll('.js-select2').forEach((select) => {
      let options = JSON.parse(select.dataset.select2 || '{}') || {}
      delete select.dataset.select2
      window.$(select).select2(options)
    })
  })
})()
